'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../common/styles');

var _styles2 = require('../../WMTable/styles');

var _styles3 = _interopRequireDefault(_styles2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	cell: function cell(props) {
		return Object.assign({}, _styles3.default.cell, {
			paddingLeft: props.first ? '24px' : 0,
			position: 'relative',
			cursor: 'pointer',
			textAlign: props.right ? 'right' : 'left',
			lineHeight: '16px',
			color: props.sort ? _styles.colors.baseColors.darkGrey : _styles.colors.baseColors.grey
		});
	},

	tooltip: function tooltip(props) {
		return {
			top: '100%',
			right: props.right ? '24px' : 'auto'
		};
	},

	sortIcon: {
		position: 'absolute',
		right: '100%',
		fontSize: '16px',
		color: _styles.colors.baseColors.darkGrey
	},

	wrapper: {
		position: 'relative'
	}
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTableHeaderCell/styles/index.js